export default __webpack_public_path__ + "static/media/green-arrow.cc93cf76.svg";